import type { VoidFunctionComponent } from 'react';
import type { PackageDetails } from '../../../../shared/organizationPackages';
import VulnBadgeCounter from './VulnBadgeCounter';
import css from './VulnSummary.module.less';

type VulnSummaryProps = {
  packageDetails: PackageDetails;
};

/**
 * A vuln summary section showing the severity count in badges.
 * @param {PackageDetails} packageDetails - A list of package details containing the vuln summary data.
 */
const VulnSummary: VoidFunctionComponent<VulnSummaryProps> = ({ packageDetails }) => {
  const { critical, high, medium, low, unknown } = packageDetails.vulnSummary;
  const hasNoVulns = !(critical + high + medium + low + unknown);

  return (
    <div className={css.vulnSummary}>
      <VulnBadgeCounter severity="critical" count={critical} isEmpty={hasNoVulns} />
      <VulnBadgeCounter severity="high" count={high} isEmpty={hasNoVulns} />
      <VulnBadgeCounter severity="medium" count={medium} isEmpty={hasNoVulns} />
      <VulnBadgeCounter severity="low" count={low} isEmpty={hasNoVulns} />
      <VulnBadgeCounter severity="unknown" count={unknown} isEmpty={hasNoVulns} />
    </div>
  );
};

export default VulnSummary;
